import React from 'react';

import Image from '../../components/Image/Image';
import RetoureForm from '../../components/account/RetoureForm';
import Currency from '../../../helpers/currency';

const OrderContentFelge = props => {
    const { images, currentOrderState, frontEndOrderActions, orderId, product, markenStandort, showRetoureLink } = props;

    return (
        <div className="uk-child-width-1-1" data-uk-grid="">
            <div>
                <div data-uk-grid="">
                    <div className="uk-width-1-1 uk-width-1-6@s">
                        <div className="uk-flex uk-flex-center">
                            <Image src={images[0]} alt="Produktbild" style={{ maxHeight: 200 }} resizeHeight={200} />
                        </div>
                    </div>
                    <div className="uk-width-expand">
                        <h2>{product.hersteller}</h2>
                        <div dangerouslySetInnerHTML={{ __html: product.bezeichnung }} />
                        <div>Artikelnummer: {product.shownId || product.id}</div>
                        {currentOrderState && (
                            <div>
                                Status: <span className="uk-text-primary">{currentOrderState?.orderStatusLabel ?? '---'}</span>
                            </div>
                        )}
                        {markenStandort && (
                            <div>
                                Autohaus: <span className="uk-text-primary">{markenStandort.anschrift.firma}</span>,{' '}
                                {markenStandort.anschrift.strasse} {markenStandort.anschrift.plz} {markenStandort.anschrift.ort}
                            </div>
                        )}
                    </div>
                    <div className="uk-width-1-1 uk-width-auto@s uk-flex uk-flex-right">
                        <table className="uk-table uk-table-small">
                            <thead>
                                <tr>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Menge</th>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Einzelpreis</th>
                                    <th className="uk-padding-remove-vertical uk-text-right uk-text-default">Summe</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="uk-text-right">
                                    <td>{product.quantity}</td>
                                    <td>
                                        <Currency quantity={product.vk_preis} />
                                    </td>
                                    <td className="uk-text-bold">
                                        <Currency quantity={product.vk_preis * product.quantity} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            {showRetoureLink && (
                <div>
                    {frontEndOrderActions.map(action => (
                        <RetoureForm key={action._id} action={action} orderId={orderId} productId={product._id} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default OrderContentFelge;
